import { TableCell } from "~/shadcn/ui/table"
import { useCastingCall } from "./CastingCallRow"

export const VisibilityCell = () => {
  const { castingCall } = useCastingCall()

  return <TableCell>{castingCall.visible ? "Yes" : "No"}</TableCell>
}
